import AiAssistMessagesAPI from 'dashboard/api/aiAssist/messages';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AiAssistMessages',
  API: AiAssistMessagesAPI,
  getters: {
    getMessagesByThreadId: state => threadId =>
      state.records
        .filter(record => record.ai_assist_thread?.id === Number(threadId))
        .sort((a, b) => a.id - b.id),
  },
  actions: mutationTypes => ({
    upsert({ commit }, data) {
      commit(mutationTypes.UPSERT, data);
    },
  }),
});
